/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Price_SaleInputs */

const cs_form_price_sale = /** @type {(inputs: Form_Price_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cena prodej`)
};

const en_form_price_sale = /** @type {(inputs: Form_Price_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sale price`)
};

/**
* | output |
* | --- |
* | "Sale price" |
*
* @param {Form_Price_SaleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_price_sale = /** @type {((inputs?: Form_Price_SaleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Price_SaleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_price_sale(inputs)
	return cs_form_price_sale(inputs)
});